import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import CovidApp from "./components/Homepage";
import Navbar from "./components/Navbar";
import Paper from "./components/Paper";
import Team from "./components/Team";
import UserDemo from "./components/UserDemo";
import Compare from './components/Compare'
import DeepAnalysis from "./components/DeepAnalysis";
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDarkMode: false,
    };
    this.setDarkMode = this.setDarkMode.bind(this);
  }

  setDarkMode(e) {
    this.setState({ isDarkMode: e.target.checked });
  }

  render() {
    const { isDarkMode } = this.state;
    return (
      <Paper isDarkMode={this.state.isDarkMode}>
        <div className="root">
          <div className="navBar">
            <Navbar isDarkMode={isDarkMode} />
          </div>
          <div className="mainContent">
            <Switch>
              <Route
                exact
                path="/"
                render={() => (
                  <CovidApp
                    setDarkMode={this.setDarkMode}
                    isDarkMode={this.state.isDarkMode}
                  />
                )}
              />
              <Route
                exact
                path="/compare"
                render={() => <Compare isDarkMode={isDarkMode} />}
              />
              <Route
                exact
                path="/deepanalysis"
                render={() => <DeepAnalysis isDarkMode={isDarkMode} />}
              />
              <Route
                exact
                path="/team"
                render={() => <Team isDarkMode={isDarkMode} />}
              />
              <Route
                exact
                path="/demo"
                render={() => <UserDemo isDarkMode={isDarkMode} />}
              />
              <Route
                path="/"
                render={() => (
                  <CovidApp
                    setDarkMode={this.setDarkMode}
                    isDarkMode={this.state.isDarkMode}
                  />
                )}
              />
            </Switch>
          </div>
        </div>
      </Paper>
    );
  }
}

export default App;
